import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navbarCollapseRef = useRef(null);
  const mobileMenuRef = useRef(null);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen); // Toggle navigation visibility
  };

  const handleNavItemClick = () => {
    setIsNavOpen(false); // Close menu after clicking a navigation item
  };

  useEffect(() => {
    const handleMobileMenuToggle = () => {
      if (navbarCollapseRef.current) {
        navbarCollapseRef.current.classList.toggle('show');
      }
    };

    const mobileMenuIcon = mobileMenuRef.current;
    mobileMenuIcon.addEventListener('click', handleMobileMenuToggle);

    return () => {
      mobileMenuIcon.removeEventListener('click', handleMobileMenuToggle);
    };
  }, []);

  return (
    <header className="header4 header7 header8">
      <div className="hdr-top-bar bluecolor ">
        <div className="container">
          <ul className="header-info">
            <li className="phn text-white"> +91 8793220265</li>
            <li className="mail ">
  <a href="mailto:info@anjalienterprisesindia.com" className='text-white'>info@anjalienterprisesindia.com</a>
</li>

          </ul>
          <div className="hdr3-right hdr4-right">
            {/* <div className="header-socials">
              <a href="https://www.facebook.com"><i className="fa fa-facebook" aria-hidden="true"></i></a>
              <a href="https://www.twitter.com"><i className="fa fa-twitter" aria-hidden="true"></i></a>
              <a href="https://www.linkedin.com"><i className="fa fa-linkedin" aria-hidden="true"></i></a>
              <a href="https://www.pinterest.com"><i className="fa fa-pinterest" aria-hidden="true"></i></a>
            </div> */}
            <div className="responsive_search-fl">
              <button name="search" type="button" className="search-btn" data-toggle="modal" data-target=".bs-example-modal-lg"></button>
            </div>
            <div className="responsiveSide">
              {/* Mobile Menu Button */}
              <button
                className={`sideOpenbtn sidebarRespButton d-lg-none ${isNavOpen ? 'toggle' : ''}`}
                onClick={toggleNav} // Handle click to toggle nav state
                aria-expanded={isNavOpen ? 'true' : 'false'}
                ref={mobileMenuRef}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="ic-bar"></span>
                <span className="ic-bar"></span>
                <span className="ic-bar"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div>
        <nav id="main-navigation-wrapper" className="navbar navbar-default navbar-expand-lg">
          <div className="container">
            <div className="navbar-header">
              <div className="logo-menu">
                <Link to="/"><img src="/images/logo.jpg" alt="logo" /></Link>
              </div>
              {/* Navbar Toggle Button (visible only in mobile view) */}
              <button
                type="button"
                className="navbar-toggler-icon collapsed d-lg-none"
                onClick={toggleNav} // Handle click to toggle nav state
                aria-expanded={isNavOpen ? 'true' : 'false'}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>

            {/* Mobile Menu */}
            <div
              id="main-navigation"
              className={`navbar-collapse ${isNavOpen ? 'show' : 'collapse'}`} // React controlled collapse class
              ref={navbarCollapseRef}
            >
              <Link to="/" className="logo">
                <img src="images/logo.jpg" className="img-responsive display-block" alt="logo" />
              </Link>
              <div className="ulDiv">
                <ul className="nav navbar-nav">
                  <li className="nav-item">
                    <Link className="nav-link active fw-bold" to="/" onClick={handleNavItemClick}>Home</Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle active fw-bold" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">About Us</Link>
                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <Link className="nav-link active fw-bold" to="/term-condition" onClick={handleNavItemClick}> <li className="nav-item">
                        <Link className="nav-link active fw-bold" to="/about-us" onClick={handleNavItemClick}>About Us</Link>
                      </li></Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link active fw-bold" to="/term-condition" onClick={handleNavItemClick}>Terms & Conditions</Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link active fw-bold" to="/privacy-policy" onClick={handleNavItemClick}>Privacy Policy</Link>
                      </li>
                  
                    </ul>
                  </li>
              
            
                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle active fw-bold" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Services</Link>
                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <Link className="nav-link active fw-bold" to="/Aluminum-Glass-Works" onClick={handleNavItemClick}>Aluminum Glass Works</Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link active fw-bold" to="/Fabrication-Works" onClick={handleNavItemClick}>Fabrication Works</Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link active fw-bold" to="/Renovation-Works" onClick={handleNavItemClick}>Renovation Works</Link>
                      </li>
                    </ul>
                  </li>
              
                  <li className="nav-item">
                    <Link className="nav-link active fw-bold" to="/portfolio" onClick={handleNavItemClick}>Portfolio</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active fw-bold" to="/gallery" onClick={handleNavItemClick}>Gallery</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active fw-bold" to="/faqs" onClick={handleNavItemClick}>Faqs</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active fw-bold" to="/contact" onClick={handleNavItemClick}>Contact</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active fw-bold" to="/blog" onClick={handleNavItemClick}>Blog</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>

      {/* Sidebar (Mobile) */}
      <div className="headerSidebar" id="headerSidebar">
        <div className="sidebar">
          <div className="sideCloseButton">
            <a href="javascript:void(0)" className="sideClosebtn" onClick={() => setIsNavOpen(false)}>×</a>
          </div>
          <div className="sideLogo">
            <Link to="/" className="logo">
              <img src="images/black-logo.png" className="img-responsive" alt="logo" />
            </Link>
          </div><br />
         
        </div>
      </div>
    </header>
  );
};

export default Header;